import { useContext, type ReactElement, useState } from 'react';
import { ClientSearchCard } from '../Components/ClientSearchCard';
import { ButtonCard } from '../Components/ButtonCard';
import { Legend } from '@/components/Calendar/Legend/Legend';
import { PlanningContainer } from '../Components/PlanningContainer';
import {
  type PlanningContextType,
  StateContext,
} from '@/layouts/Planning/PlanningLayout';
import { openNewTaskModal } from '../Modals/NewTaskModal';
import { FormModal } from '@/components/Modal/FormModal';
import { useDisclosure } from '@mantine/hooks';
import PlanningActionHandler from '@/pages/Planning/Helpers/PlanningActionHandler';

export const PlanningPage = (): ReactElement => {
  const { clientPlanId, month } = useContext<PlanningContextType>(StateContext);
  const [toForPlanningStateOpened, { toggle: toggleToForPlanningState }] =
    useDisclosure(false);
  const [toPlannedStateOpened, { toggle: toggleToPlannedState }] =
    useDisclosure(false);
  const [deleteAssignmentsOpened, { toggle: toggleDeleteAssignments }] =
    useDisclosure(false);
  const [updateKey, setUpdateKey] = useState(0); // Add a state to force rerender

  const {
    handleToForPlanningState,
    handleToPlannedState,
    noClientPlanSelected,
    cancelAllAssignments,
  } = PlanningActionHandler();

  return (
    <PlanningContainer key={updateKey}>
      <ClientSearchCard planState="NOT_PLANNED" />
      <ButtonCard
        header="Požadavky"
        buttons={[
          {
            label: 'Přidat úkol',
            onClick: () =>
              openNewTaskModal(
                clientPlanId,
                month,
                () => setUpdateKey(prevKey => prevKey + 1) // Update the state to force rerender
              ),
          },
        ]}
      />
      <ButtonCard
        header="Přesunout plán do"
        buttons={[
          {
            label: 'K Doplánování',
            onClick: () =>
              clientPlanId
                ? toggleToForPlanningState()
                : noClientPlanSelected(clientPlanId),
          },
          {
            label: 'Naplánováno',
            onClick: () =>
              clientPlanId
                ? toggleToPlannedState()
                : noClientPlanSelected(clientPlanId),
          },
        ]}
      />
      <ButtonCard
        header="Hromadné akce"
        buttons={[
          {
            label: (
              <span>
                Zrušit všechna <br /> přiřazení
              </span>
            ),
            onClick: () =>
              clientPlanId
                ? toggleDeleteAssignments()
                : noClientPlanSelected(clientPlanId),
          },
        ]}
      />
      <FormModal
        opened={toForPlanningStateOpened}
        onClose={() => {
          toggleToForPlanningState();
        }}
        onConfirm={async event => {
          await handleToForPlanningState(
            event,
            clientPlanId,
            toggleToForPlanningState
          );
          setUpdateKey(prevKey => prevKey + 1); // Update the state to force rerender
        }}
        title={
          'Opravdu si přejete přesunout měsíční plán klienta do sekce K doplánování?'
        }
        confirmText={'Ano'}
      ></FormModal>
      <FormModal
        opened={toPlannedStateOpened}
        onClose={() => {
          toggleToPlannedState();
        }}
        onConfirm={async event => {
          await handleToPlannedState(event, clientPlanId, toggleToPlannedState);
          setUpdateKey(prevKey => prevKey + 1); // Update the state to force rerender
        }}
        title={
          'Opravdu si přejete přesunout měsíční plán klienta do sekce Naplánováno?'
        }
        confirmText={'Ano'}
      ></FormModal>
      <FormModal
        opened={deleteAssignmentsOpened}
        onClose={() => {
          toggleDeleteAssignments();
        }}
        onConfirm={async event => {
          await cancelAllAssignments(
            event,
            clientPlanId,
            toggleDeleteAssignments
          );
          setUpdateKey(prevKey => prevKey + 1); // Update the state to force rerender
        }}
        title={'Opravdu si přejete smazat všechna přiřazení k úkolům klienta?'}
        confirmText={'Ano'}
      ></FormModal>
      <Legend
        label="Legenda"
        colors={[
          {
            label: 'Nepřiřazené',
            color: '#A0A0A0',
          },
          {
            label: 'Přiřazené',
            color: '#0000F0',
          },
        ]}
      />
    </PlanningContainer>
  );
};
